export type Tone = "ok" | "warn" | "critical" | "neutral" | "locked";

export function healthTone(status: string | undefined, ok: boolean): Tone {
  if (!ok) return "critical";
  if (status === "ok" || status === "ready") return "ok";
  return "warn";
}

export function liveTone(liveEnabled: boolean | undefined): Tone {
  if (liveEnabled === true) return "critical";
  return "ok";
}

export function modeLabel(mode: string | undefined): string {
  if (!mode) return "unknown";
  return mode;
}
